export function qs(obj, prefix){
	var str = [];
	for (var p in obj) {
		var k = prefix ? prefix + "[" + p + "]" : p, 
		v = obj[p];
		str.push(typeof(v) == 'object' ? qs(v, k) : (k) + "=" + encodeURIComponent(v));
	}
	return str.join("&");
}

export function gParser(obj) {
	console.log('parse this object... ', obj);
	var rawObj = JSON.stringify(obj);
	var out = {
		address : obj.formatted_address,
		latLng : [obj.geometry.location.lat, obj.geometry.location.lng],
		raw : rawObj
	}
	obj.address_components.forEach(function(address_component) {
		if (address_component.types.length != 0 && address_component.types[0]!='political'){
			switch(address_component.types[0]) {
				case 'administrative_area_level_1':
					out.province = address_component.long_name
					break;
				case 'administrative_area_level_2':
					out.kabupaten = address_component.long_name
					break;
				case 'administrative_area_level_3':
					out.kelurahan = address_component.long_name
					break;
				case 'administrative_area_level_4':
					out.kecamatan = address_component.long_name
					break;
				case 'route':
					out.street = address_component.long_name
					break;
				case 'street_number':
					out.steetNo = address_component.long_name
					break;
				case 'country':
					out.country = address_component.long_name
					break;
				case 'postal_code':
					out.postCode = address_component.long_name
					break;
				default:
					console.log(address_component.types[0], address_component.long_name)
			}
		} else {
			console.log('No Use : ' + address_component.types + ' ' + address_component.long_name)
		}
	});
	return out;
}

export function stringifyErrors(err){
	console.log(err);
	var errors = err.data;
	var eString = errors.status.error.message;
	if (errors.status.error.errors&&errors.status.error.errors.length > 0){
		errors.status.error.errors.forEach((errors)=>{
			// console.log('E3: ', errors);
			if (Array.isArray(errors)){
				errors.forEach((error)=>{
					// console.log('E4: ', error);	
					eString =  eString + ' - ' + error.message;
					// this.formStatus[error.field].state = false;
					// this.formStatus[error.field].message = error.message;
				})
			}
		})
	}
	return eString;
}


// WEBPACK FOOTER //
// src/util/utils.js